export default __webpack_public_path__ + "static/media/qrcode-sara.dd218f5d.svg";